<fo-side-panel
  [title]="'ASSET_CATEGORY_SIDEBAR_CREATE' | i18nextCap"
  [nested]="inputs.nested === true"
  [backAriaLabel]="'goBack' | i18nextCap"
  [closeAriaLabel]="'close' | i18nextCap"
  (closed)="inputs.onCancel()"
>
  <form (ngSubmit)="save()">
    <mat-form-field>
      <mat-label>{{ 'name' | i18nextCap }}</mat-label>
      <input matInput [formControl]="nameControl" type="text" />
      @if (nameControl.errors?.['error']; as error) {
        <mat-error>{{ error | i18nextCap }}</mat-error>
      }
    </mat-form-field>
    <div class="footer">
      <button mat-flat-button color="primary" type="submit">
        {{ 'save' | i18nextCap }}
      </button>
    </div>
  </form>
</fo-side-panel>
